enum RouteBuilderStep {
  SETUP_ROUTE,
  ADJUST_STEPS,
  FINALIZE,
}

export default RouteBuilderStep;
